import { useQuery } from '@tanstack/react-query';
import { getAllLinkedinAccounts } from 'API/linkedin-accounts';
import _ from 'lodash';
import { UserInfo } from 'types/user.types';
import { LinkedinAccount } from '../linkedin-accounts.types';

interface UseLinkedinAccountsQueryOptions {
  prioritizeCurrentUser?: boolean;
  /** Regelmäßig neu laden (ms), z. B. für den Verbindungshinweis in der oberen Leiste. */
  refetchInterval?: number;
}

const prioritizeCurrentUserAccount = (accounts: LinkedinAccount[]): LinkedinAccount[] => {
  const userDetails = localStorage.getItem('user-details');
  const parsedUserDetails: UserInfo | undefined = !_.isNil(userDetails) ? JSON.parse(userDetails) : undefined;

  if (_.isNil(parsedUserDetails)) {
    return accounts;
  }

  const { firstName, lastName } = parsedUserDetails;
  const userAccount = accounts.find((account) => account.firstName === firstName && account.lastName === lastName);

  if (_.isNil(userAccount)) {
    return accounts;
  }

  return [userAccount, ...accounts.filter((account) => account !== userAccount)];
};

export const useLinkedinAccountsQuery = (options?: UseLinkedinAccountsQueryOptions) => {
  const { prioritizeCurrentUser = false, refetchInterval } = options || {};

  return useQuery<LinkedinAccount[], any>({
    queryKey: ['linkedinAccounts', 'all', prioritizeCurrentUser],
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    refetchInterval,
    queryFn: async () => {
      const res = await getAllLinkedinAccounts();

      if (res.error) {
        throw res.error;
      }

      const accounts: LinkedinAccount[] = res.allLinkedInAccounts || [];

      if (prioritizeCurrentUser) {
        return prioritizeCurrentUserAccount(accounts);
      }

      return accounts;
    },
  });
};
